import React from 'react';
import { FormattedMessage } from 'react-intl';
import PulpoField from '../../../pulpo_visualizer/fields';
import CustomField from '../../../components/customFields/customField';
import Button from '../../../components/button/button';
import style from '../../sms/hazard_create.module.scss';
import styles from '../../sms/hazard_builder.module.scss';

const WaitRequestForm = ({
  handleAnswerChanged,
  handleFieldsAnswerChanged,
  handleFieldErrorChanged,
  showFormErrors,
  info,
  requiredMap,
  answers,
  airport_data,
  create,
  fieldsOrdering,
  dataSchema,
  defaultFieldSchema,
  datasources,
  isWaitListCreate
}) => (
  <div className={styles.box}>
    <div className={styles.title}>
      <FormattedMessage
        id="sms.new.newHazards"
        defaultMessage={'Request Form'}
      />
    </div>
    <div className={styles.content}>
      <div className={`${styles.details_form} ${info?.is_anonymous ? styles.reportInfoStyle : ''}`}>
        {fieldsOrdering?.map(field => (
          <>
          {field === 'default_first_name' && (
            <PulpoField
              key="wait_report_date"
              id="wait_report_date"
              type="date"
              customField
              translationID={defaultFieldSchema?.[field] ? 'invalid' : 'hazard.report_date'}
              title={'Reported Date'}
              isRequired
              description={defaultFieldSchema?.[field]?.description || ''}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              answer={info?.wait_report_date}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
              Badging
            />
          )}
          {field === 'default_first_name' && (
              <PulpoField
              key="report_time"
              onlyTime
              customField
              id="report_time"
              type="datetime"
              translationID={defaultFieldSchema?.[field] ? 'invalid' : 'hazard.report_time'}
              title={'Time'}
              isRequired
              description={defaultFieldSchema?.[field]?.description || ''}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              answer={info?.report_time}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
               />
          )}
              {field === 'default_first_name' && (
                <PulpoField
                  key="first_name"
                  id="first_name"
                  type="string"
                  isRequired
                  className={`${styles.fullInput} ${styles.noMarginLeft}`}
                  translationID={'First Name'}
                  title={defaultFieldSchema?.[field] ? defaultFieldSchema?.[field]?.title : 'First Name'}
                  description={defaultFieldSchema?.[field]?.description || ''}
                  handleValueChange={(a, b) => handleAnswerChanged(a, b)}
                  answer={info?.first_name}
                  showFieldErrors={showFormErrors}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  fromSMS
                />
            )}
            {field === 'default_last_name' && (
              <PulpoField
                key="last_name"
                id="last_name"
                type="string"
                isRequired
                className={`${styles.fullInput} ${styles.noMarginLeft}`}
                translationID={'Last Name'}
                title={defaultFieldSchema?.[field] ? defaultFieldSchema?.[field]?.title : 'Last Name'}
                description={defaultFieldSchema?.[field]?.description || ''}
                handleValueChange={(a, b) => handleAnswerChanged(a, b)}
                answer={info?.last_name}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                fromSMS
              />
            )}
            {field === 'default_email'
              && (
                <PulpoField
                  key="email"
                  id="email"
                  type="string"
                  isRequired
                  className={`${styles.fullInput} ${styles.noMarginLeft}`}
                  translationID={'Email'}
                  title={defaultFieldSchema?.[field] ? defaultFieldSchema?.[field]?.title : 'Email'}
                  description={defaultFieldSchema?.[field]?.description || ''}
                  handleValueChange={(a, b) => handleAnswerChanged(a, b)}
                  answer={info?.email}
                  showFieldErrors={showFormErrors}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  fromSMS
              />
            )}
            {field === 'default_phone' && (
              <PulpoField
                key="phone"
                id="phone"
                type="telephone"
                isRequired
                className={`${styles.fullInput} ${styles.noMarginLeft}`}
                translationID={'Phone'}
                title={defaultFieldSchema?.[field] ? defaultFieldSchema?.[field]?.title : 'Phone'}
                description={defaultFieldSchema?.[field]?.description || ''}
                handleValueChange={(a, b) => handleAnswerChanged(a, b)}
                answer={info?.phone}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                fromSMS
              />
            )}
            {field === 'default_location' && (
              <PulpoField
              key="location"
              id="location"
              type="select"
              isRequired={defaultFieldSchema?.[field]?.required || true}
              translationID={'Location'}
              title={defaultFieldSchema?.[field] ? defaultFieldSchema?.[field]?.title : 'Location'}
              description={defaultFieldSchema?.[field]?.description || ''}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              values={defaultFieldSchema?.[field]?.values}
              answer={info.location}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
              fromSMS
            />
            )}
            {field === 'default_preferences' && (
              <PulpoField
              key="size_preference"
              id="size_preference"
              type="multiselect"
              widget={{ type: 'dropdown' }}
              translationID={'Size Preferences'}
              title={defaultFieldSchema?.[field] ? defaultFieldSchema?.[field]?.title : 'Size Preferences'}
              isRequired={defaultFieldSchema?.[field]?.required || true}
              description={defaultFieldSchema?.[field]?.description || ''}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              values={defaultFieldSchema?.[field]?.values || []}
              answer={info.size_preference}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
              fromSMS
            />
            )}
        {!field.includes('default_') && Object.keys(requiredMap || {})?.length > 0 && (
            <CustomField
              handleAnswerChanged={handleFieldsAnswerChanged}
              handleFieldErrorChanged={handleFieldErrorChanged}
              answers={answers}
              info={info}
              showFormErrors={showFormErrors}
              requiredMap={requiredMap}
              fields={dataSchema}
              airport_data={airport_data}
              forSmsPublic
              orderField={field}
              datasources={datasources}
              isWaitListCreate={isWaitListCreate}
            />
        )}
          </>
    ))}
      </div>
    </div>
    <div className={styles.footerSingle}>
      <div className={styles.saveBtns}>
        <div className={`${style.footer} ${style.embedded}`}>
          <Button
            action="secondary"
            onClick={() => create()}
            translationID="hazard.new.finish"
            defaultText="Create"
          />
        </div>
      </div>
    </div>
  </div>
);

export default WaitRequestForm;
